import type { CardHooks } from "./registry";

/**
 * Serpent's Prick — Light Thrust A/D.
 *
 * Pure-data card; no engine hook required:
 *   - Attack: Power 3, Chain
 *   - Defend: Brace 3, Stun
 *   - No counter ability in Phase 2
 *
 * Stats live entirely in Supabase (`attackDefendFields` + `keywordSlots`);
 * the Stun keyword fires through the standard keyword pipeline.
 *
 * We export an empty hooks object so that if a future patch adds card-
 * specific behaviour (e.g. a Stun-rider), the registry plumbing is already
 * in place.
 */
export const serpentsPrick: CardHooks = {};
